module.exports = __webpack_public_path__ + "img/bgtop.c257a430.jpg";